/**
 * Copyright 2022 (C) Blink - All Rights Reserved
 *
 * This source code is protected under international copyright law.  All rights
 * reserved and protected by the copyright holders.
 * All files are confidential and only available to authorized individuals with the
 * permission of the copyright holders. If you encounter any file and do not have
 * permission, please get in touch with the copyright holders and delete this file.
 */
import cn from "classnames";

import s from "./Portal.module.css";
import { UIGlobalsInterface } from "../Drawer/Drawer";

const Portal = ({
  children,
  isOpen,
  className,
  id = "portal",
}: UIGlobalsInterface) => {
  return (
    <div
      className={cn(s.root, isOpen ? s.open : s.hide, className)}
      tabIndex={-1}
      onClick={(e) => {
        e.stopPropagation();
      }}
      id={id}
      test-id="xvbOvzvs"
    >
      {children}
    </div>
  );
};

export default Portal;
